<div class="header">
    <div class="logo logo-dark">
        <a href="" *ngIf="isAdmin">
          <div class="m-t-20">
            Fmarket Admin
          </div>
        </a>
        <div class="m-t-20 text-center" *ngIf="!isAdmin">
            <span>Fmarket Admin</span>
        </div>
    </div>
    <div class="nav-wrap">
        <ul class="nav-left">
            <li class="desktop-toggle">
                <a (click)="toggleFold()">
                    <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" theme="outline"></i>
                </a>
            </li>
            <li class="mobile-toggle">
                <a (click)="toggleExpand()">
                    <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" theme="outline"></i>
                </a>
            </li>
        </ul>
        
        <ul class="nav-right">
            <li>
                <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'" [nzPlacement]="'bottomRight'">
                    <nz-avatar [nzSize]="32" nzIcon="user" style="background-color:#87d068;"></nz-avatar>
                </span>
                <nz-dropdown-menu #profile="nzDropdownMenu">
                    <ul nz-menu class="p-b-15 p-t-20">
                        <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                            <div class="d-flex m-r-50">
                                <div class="m-l-10">
                                    <p class="m-b-0 text-dark font-weight-semibold">{{accountInfo?.account}}</p>
                                </div>
                            </div>
                        </li>
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="logout" theme="outline"></i>
                                    <span class="m-l-10" (click)="logout()">Logout</span>
                                </div>
                                <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
                            </a>
                        </li>
                    </ul>
                </nz-dropdown-menu >
            </li>
        </ul>
    </div>
</div>
<!-- <div class="container-color">
    <div class="list-color" *ngIf="!isHide">
        <div class="d-flex" (click)="changeTheme('primary')" style="cursor: pointer;">
            <div class="color color-primary mb-2" [class.active-color]="theme === 'primary'"></div>
            <span class="ml-3">Primary </span>
        </div>
        <div class="d-flex" (click)="changeTheme('dark-night')" style="cursor: pointer;">
            <div class="color color-dark-night mb-2" [class.active-color]="theme === 'dark-night'"></div>
            <span class="ml-3">Dark </span>
        </div>
        <div class="d-flex"  (click)="changeTheme('default')" style="cursor: pointer;">
            <div class="color color-default mb-2" [class.active-color]="theme === 'default'"></div>
            <span class="ml-3">Default </span>
        </div>
        <div class="d-flex"  (click)="changeTheme('dynamic')" style="cursor: pointer;">
            <div class="color color-dynamic mb-2" [class.active-color]="theme === 'dynamic'"></div>
            <span class="ml-3">Dynamic </span>
        </div>

        <div class="sub-dynamic-color d-flex flex-column" *ngIf="theme === 'dynamic'">
            <input (colorPickerChange)="changeColor($event)"  [style.background]="color" [cpPosition]="'left'" style="display: none;" id="idPickColor"/> 
            <div class="d-flex">
                <span class="mr-2">Background color: </span>
                <input [(colorPicker)]="color" [style.background]="color"/> 
                <div class="color" [style.background-color]="dynamicColor.color" [(colorPicker)]="color"  
                [cpPosition]="'left'" (colorPickerSelect)="changeColor('color')" [(colorPicker)]="dynamicColor.color"></div> 
            </div>
            <div class="d-flex">
                <span class="mr-2">Text color: </span>
                <div class="color" [style.background-color]="dynamicColor.color1" [(colorPicker)]="color"  
                [cpPosition]="'left'" (colorPickerSelect)="changeColor('color1')" [(colorPicker)]="dynamicColor.color1"></div>
            </div> 
            
            <div class="d-flex">
                <span class="mr-2">Màu phụ 3: </span>
                <div class="color" [style.background-color]="dynamicColor.color3" [(colorPicker)]="color"  
                [cpPosition]="'left'" (colorPickerSelect)="changeColor('color3')" [(colorPicker)]="dynamicColor.color3"></div>
            </div> 
            <div class="d-flex">
                <span class="mr-2">Menu effect: </span>
                <div class="color" [style.background-color]="dynamicColor.color4" [(colorPicker)]="color"  
                [cpPosition]="'left'" (colorPickerSelect)="changeColor('color4')" [(colorPicker)]="dynamicColor.color4"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Table background: </span>
                <div class="color" [style.background-color]="dynamicColor.color5" [(colorPicker)]="color"  
                [cpPosition]="'left'" (colorPickerSelect)="changeColor('color5')" [(colorPicker)]="dynamicColor.color5"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Table body text: </span>
                <div class="color" [style.background-color]="dynamicColor.color2" [(colorPicker)]="color"  
                [cpPosition]="'left'" (colorPickerSelect)="changeColor('color2')" [(colorPicker)]="dynamicColor.color2"></div>
            </div>
        </div>
    </div>
    <div class="btn-container btn-container-right" (click)="hideTheme()" *ngIf="!isHide">
        <i class="font-size-10 icon-hide" nz-icon nzType="right" theme="outline"></i>
    </div>
    <div class="btn-container btn-container-left" (click)="showTheme()" *ngIf="isHide">
        <i class="font-size-10 icon-hide" nz-icon nzType="left" theme="outline"></i>
        <span class="ml-1">Theme</span>
    </div>
</div> -->